











import { Component, Prop, Vue } from 'vue-property-decorator';
import { SliderMark } from './types/SliderTypes';

@Component
export default class VueSmartSliderMark extends Vue {
  @Prop({ required: true, type: Object }) readonly propMark!: SliderMark;

  @Prop({ required: true, type: Number }) readonly propWidth!: number;

  @Prop({ required: true, type: Number }) readonly propMax!: number;

  get markPosition(): number {
    return this.propMark.value / this.propMax * 100;
  }
}
